<app-modal-header></app-modal-header>

<ion-content class="safe-area-top white">


    <div class="content-spacing px-md">

        <div class="ts-h1" [innerHTML]="'Preparati a fare di più' | translate"></div>
        <div class="ts-body pt-md" [innerHTML]="'Attiva le funzionalità' | translate"></div>

        <div class="mt-md">
            <div *ngFor="let feature of features"
                 style="min-height: 80px;"
                 class="app-card-box mb-sm d-flex ion-align-items-center gap-2 app-border w-100">
                <div>
                    <span [ngStyle]="{color: feature.color}"
                          class="material-symbols-outlined app-mt-icon">{{ feature.icon }}</span>
                </div>
                <div>
                    <div class="ts-body-bold" [innerHTML]="feature.title | translate"></div>
                    <div class="ts-caption" [innerHTML]="feature.description | translate"></div>
                </div>
            </div>
        </div>


    </div>


</ion-content>
<ion-footer>
    <ion-toolbar>
        <div class="d-flex">
            <ion-button (click)="onRegister()"
                        class="w-100">{{ 'Accedi o registrati' | translate }}
            </ion-button>
        </div>
    </ion-toolbar>
</ion-footer>
